export default __webpack_public_path__ + "static/media/bag.dacf7991.svg";